import { Card } from "@volca/ui/components/ui/card";
import { AdditionalNoticesSection } from "./sections/additional-notices-section";
import { CommunicationsSection } from "./sections/communications-section";
import { CookiesSection } from "./sections/cookies-section";
import { DataCollectionSection } from "./sections/data-collection-section";
import { DataControllerProcessorSection } from "./sections/data-controller-processor-section";
import { DataLocationSection } from "./sections/data-location-section";
import { DataRetentionSection } from "./sections/data-retention-section";
import { DataSecuritySection } from "./sections/data-security-section";
import { DataSharingSection } from "./sections/data-sharing-section";
import { DataSubjectRightsSection } from "./sections/data-subject-rights-section";
import { DataUsesSection } from "./sections/data-uses-section";
import { IntroSection } from "./sections/intro-section";

const PrivacyPolicy = () => (
  <div className="h-full w-full overflow-y-auto px-4 sm:px-8">
    <Card className="my-10 h-full w-full max-w-[1440px] gap-0 p-6 py-0">
      <article className="typeset typeset-document w-full max-w-[800px] py-6">
        <h1>Privacy Policy</h1>
        <IntroSection />
        <DataCollectionSection />
        <DataUsesSection />
        <DataLocationSection />
        <DataRetentionSection />
        <DataSharingSection />
        <CookiesSection />
        <CommunicationsSection />
        <DataSecuritySection />
        <DataSubjectRightsSection />
        <DataControllerProcessorSection />
        <AdditionalNoticesSection />
      </article>
    </Card>
  </div>
);

export default PrivacyPolicy;
